import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { useSettingReviewsDisplayGranularRatingsXP } from "@faire/retailer-visitor-shared/settings/useSettingDisplayGranularRatingsXP";

export const useShouldDisplayV2ReviewsList = () => {
  const isRetailerInTreatment = useSettingReviewsDisplayGranularRatingsXP();
  const isBrandPreview = useIsBrandPreview();
  return isRetailerInTreatment || isBrandPreview;
};
